import { createIdSlice } from '../utils/action/createElementSlice';
export const WarningState = createIdSlice({
    elementName: 'warning',
    initialState: {},
    reducers: {
        set: (_state, action) => {
            return action.payload.data;
        },
    },
});
